export enum DeliveryMethod {
  InstantFeedback = 'instantFeedback',
  OpenNavigation = 'openNavigation',
  TeacherPaced = 'teacherPaced',
  SpaceRace = 'spaceRace',
}
